// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-error-dialog-docs',
    templateUrl: './error-dialog.docs.generated.html',
})
export class UIErrorDialogDocs { }
